import React from "react";
import classNames from "classnames";
import "component/card/works/webAppCard.scss";
function WebAppCard(props) {
    var _a;
    var type = props.type, title = props.title, text = props.text, services = props.services, link = props.link, linkText = props.linkText, image = props.image, _b = props.reverse, reverse = _b === void 0 ? false : _b, _c = props.container, container = _c === void 0 ? "" : _c, btnPositionLeft = props.btnPositionLeft;
    var mainContainer = classNames((_a = {
            "py-20 bg-secondBgColor": true
        },
        _a[container] = container,
        _a));
    var main = classNames({
        "sizeScreen flex flex-wrap": true,
        "flex-row-reverse": reverse,
    });
    var mainContent = classNames({
        "w-full lg:w-2/5 flex flex-col justify-between": true,
        "lg:rtl:pl-10 lg:ltr:pr-10": !reverse,
        "lg:rtl:pr-10 lg:ltr:pl-10": reverse,
    });
    var btnContainer = classNames({
        flex: true,
        "justify-end": btnPositionLeft,
    });
    return (React.createElement("div", { className: mainContainer },
        React.createElement("div", { className: main },
            React.createElement("div", { className: mainContent },
                React.createElement("div", null,
                    React.createElement("div", { className: "text-16 font-light" }, type),
                    React.createElement("div", { className: "text-30 font-bold my-5" }, title),
                    React.createElement("div", { className: "text-16 font-normal leading-6 whitespace-pre-wrap text-justify" }, text),
                    React.createElement("div", { className: "text-16 font-normal text-left mt-5" }, services)),
                React.createElement("div", { className: "mt-5" },
                    React.createElement("a", { href: link, target: "_blank", rel: "nofollow noopener noreferrer", className: btnContainer },
                        React.createElement("div", { className: "w-max px-8 py-1 border border-black border-opacity-20 hover:border-opacity-50 rounded" }, linkText)))),
            React.createElement("div", { className: "container border border-black border-opacity-30 rounded-md shadow w-full lg:w-3/5 m-auto lg:mt-0 mt-3" }, image))));
}
export default WebAppCard;
